import { parseISO, differenceInDays } from 'date-fns';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../mixins/translate/translate';
import { openApiFetchGet, openApiFetchPost } from '../../store/openApiFetch';
import { Modal } from '../common/Modal/Modal';
import { EditPanelButton } from '../elements';

export function DashboardMfaPopup() {
    const translate = useTranslate();
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = React.useState<boolean>(true);
    const [canClose, setCanClose] = React.useState<boolean>(false);

    useEffect(() => {
        async function load() {
            const user = await openApiFetchGet('/api/user', {});
            if (user.enableOtpMessageFirstShownOn === null) {
                setCanClose(true);
                await openApiFetchPost('/api/user', {}, { enableOtpMessageFirstShownOn: new Date().toISOString() });
            } else {
                const firstShownDate = parseISO(user.enableOtpMessageFirstShownOn);
                const daysDifference = differenceInDays(new Date(), firstShownDate);
                if (daysDifference <= 10) {
                    setCanClose(true);
                }
            }
        }
        void load();
    }, []);

    function closePopup() {
        if (canClose) {
            setIsVisible(false);
        }
    }

    return (
        <>
            {isVisible && (
                <Modal id="map-dialog" classNames="confirm-dialog" closeOnBackdropClick={canClose} onClose={closePopup}>
                    <Modal.Title shouldHideCloseButton={!canClose}>{translate('dashboard.faWarningTitle')}</Modal.Title>
                    <Modal.Content isScrollBarVisible={true} style={{ height: '140px', width: '280x' }}>
                        {translate('dashboard.faWarning1')}
                        <br />
                        {translate('dashboard.faWarning2')}
                    </Modal.Content>
                    <Modal.Actions>
                        {canClose && <EditPanelButton small={true} text={translate('common.close')} onClick={closePopup} />}
                        <EditPanelButton small={true} primary={true} text={translate('dashboard.goToProfile')} onClick={() => navigate('/profile')} />
                    </Modal.Actions>
                </Modal>
            )}
        </>
    );
}
